import MTextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useState } from "react";
import { DateIcon } from "components/atoms/Icon";
import Label from "./Label";
import ErrorMessage from "./ErrorMessage";

type DatePickerProps = {
  startDateTime: number | null | moment.Moment | Date;
  error: any;
  isDatePickerModalOpen: boolean;
  setIsDatePickerModalOpen: (s: boolean) => void;
  handleSetDateTimeForMomemto: (value: Date | null) => void;
  label: string;
  minDate: Date;
  id: string;
  isDisabled?: boolean;
};

function DatePickerInput({
  startDateTime,
  error,
  isDatePickerModalOpen,
  setIsDatePickerModalOpen,
  handleSetDateTimeForMomemto,
  label,
  minDate,
  isDisabled,
  id,
}: DatePickerProps) {
  const StyledMTextField = styled(MTextField)(() => ({
    "& .MuiInputBase-input": {
      boxShadow: "none",
      fontFamily: "satoshi",
      color: "white",
      fontWeight: "500",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "10px",
      borderColor: "#22222255",
      borderWidth: "1px",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
        textColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
        textColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
        textColor: "white",
      },
    },
  }));

  const [anchorEl, setAnchorEl] = useState<any>(null);

  return (
    <div>
      <Label label={label} htmlFor={id} labelClasses="text-xxs 2xl:text-xs" />

      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DateTimePicker
          components={{
            OpenPickerIcon: DateIcon,
          }}
          renderInput={(props) => (
            <div onClick={(e) => setAnchorEl(e.currentTarget)}>
              <StyledMTextField
                fullWidth
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
              />
            </div>
          )}
          open={isDatePickerModalOpen}
          PopperProps={{
            placement: "bottom-start",
            anchorEl,
          }}
          onOpen={() => setIsDatePickerModalOpen(true)}
          onClose={() => setIsDatePickerModalOpen(false)}
          value={startDateTime}
          minDate={minDate}
          disabled={isDisabled}
          onChange={handleSetDateTimeForMomemto}
          closeOnSelect
          inputFormat="MMM DD YY hh:mm A"
          disableMaskedInput
        />
      </LocalizationProvider>
      <ErrorMessage errorMessage={error} />
    </div>
  );
}

export default DatePickerInput;
